import { styled } from '@mui/material';
import { Chip } from '@mui/material';

export const DateRangePickerContainer = styled('div')`
  position: relative;
  box-sizing: border-box;
  width: auto;
  min-width: auto;
  .calendar-icon {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 7px;
    top: 12px;
  }
`;

export const DateRangeListContainer = styled('div')`
  width: auto;
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  gap: 16px;
`;

export const DateRangeListChip = styled(Chip)<{ selected: boolean }>`
  background-color: ${props => (props.selected ? props.theme.palette.white.main : props.theme.palette.primary.main)};
  span {
    color: ${props => (props.selected ? props.theme.palette.primary.main : props.theme.palette.white.main)};
  }
  border: ${props => (props.selected ? `1px solid ${props.theme.palette.primary.light}` : 'none')};
  &:focus-visible,
  &:hover {
    background-color: ${props => (props.selected ? props.theme.palette.grey[100] : props.theme.palette.primary.light)};
  }
`;

export const StyledSingleInputDateRangeField = {
  backgroundcolor: '#ffffff',
  minWidth: '260px',
  textAlign: 'left',
};
